import React from 'react';
import { Form, Tag } from 'antd';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';

interface LabNewTaskFormProps {
  form: any;
  editable: boolean;
  status: string | null;
  departmentOptions?: { label: string; value: number }[];
}

const LabNewTaskForm: React.FC<LabNewTaskFormProps> = ({ form, editable, status, departmentOptions = [] }) => {
  const isFormEditable = editable && (status === null || status === 'DRAFT');
  const departmentIds = Form.useWatch('department_ids', form) || [];
  // Convert department id to its label
  departmentIds.map((id: number | string) => {
    const label = departmentOptions.find((opt) => String(opt.value) === String(id))?.label;
    return <Tag key={id}>{label || id}</Tag>;
  });

  console.log('LabNewTaskForm departmentOptions:', departmentOptions);
  console.log('LabNewTaskForm form:', form.getFieldsValue());

  return (
    <Form
      form={form}
      name="labNewTaskForm"
      initialValues={form.getFieldsValue()}
      size="small"
      labelCol={{ lg: { span: 6 }, md: { span: 6 }, sm: { span: 24 } }}
      labelAlign="left"
      labelWrap
      wrapperCol={{ lg: { span: 16 }, md: { span: 18 }, sm: { span: 24 } }}
    >
      <BaseRow gutter={[16, 16]}>
        <BaseCol xs={24} md={8} lg={12}>
          <Form.Item
            name="department_ids"
            label="Divisions"
            rules={[{ required: true, message: 'Please select at least one division' }]}
          >
            {isFormEditable ? (
              <BaseSelect mode="tags" placeholder="Select Divisions" options={departmentOptions} />
            ) : (
              <div style={{ paddingTop: 4 }}>
                {departmentIds.length > 0 ? (
                  departmentIds.map((dept: { value: number | string; label: string }) => (
                    <Tag key={dept.value}>{dept.label}</Tag>
                  ))
                ) : (
                  <span style={{ color: '#999' }}>No divisions selected</span>
                )}
              </div>
            )}
          </Form.Item>
        </BaseCol>

        <BaseCol xs={24} md={8} lg={12}>
          <Form.Item name="description" label="Other Details">
            <BaseInput.TextArea placeholder="Enter additional info..." rows={4} readOnly={!isFormEditable} />
          </Form.Item>
        </BaseCol>
      </BaseRow>
    </Form>
  );
};

export default LabNewTaskForm;
